export const environment = {
  production: false,
  securityenabled: true,
  apiBaseUrl: 'https://marpal-dev-api.co3.xyz',
  loginUrl: 'login',
  showDashboardOnProperty: true,
  showDashboardOnProject: false,

  // azure ad
  apiScope: '',
  azureADClientId: '',
  azureADAuthority: '',
  azureADRedirectUri: '',

  globalConfig: {
    globalSettings: {
      msalLogin: false,
      standardLogin: true,
      bootstrap: false,
      tailwind: true,
      collapseMenu: true,
      collapseMenuByDefault: false,
      logoInMenu: true,
      logoOnLogin: true,
      poweredByCCC: true,
      portalName: 'Marpal Fire Safety',
    },
    globalTheme: {
      primarySiteColor: '#990100',
      secondarySiteColor: '#F87E7F',
      tertiarySiteColor: '#5DC7CC',
      logoDarkUrl: '/assets/250121-MFS-Logo.png',
      logoLightUrl: '/assets/250121-MFS-Logo.png',
      logoLightIconUrl: '/assets/250121-MFS-Logo.png',
      logoCCCUrl: 'assets/ccc-light.webp',
      critical: '#c00000',
      high: '#ff0000',
      medium: '#f79646',
      low: '#92d050',
      veryLow: '#375623',
    },
  },
};
